/** Ticket #839 — visibilité de la finalisation après ajout au panier. */

export const CART_FINALIZE_PROMPT_TEST_ID = 'cart-finalize-prompt';
export const CART_FINALIZE_STICKY_CLASS = 'cart-finalize-prompt--sticky';

const RECENT_ADD_HIGHLIGHT_MS = 90_000;

export type CartFinalizeVisibilityInput = {
  checkoutEnabled: boolean;
  itemCount: number;
  pathname: string;
};

/** Bandeau + CTA tant qu'il reste des articles non confirmés (hors checkout / embed). */
export function shouldShowCartFinalizePrompt(input: CartFinalizeVisibilityInput): boolean {
  const { checkoutEnabled, itemCount, pathname } = input;
  if (!checkoutEnabled || itemCount <= 0) return false;
  if (pathname.includes('/checkout')) return false;
  if (pathname.startsWith('/embed/')) return false;
  return true;
}

export function isCartRecentlyHighlighted(
  lastAddedAtMs: number | null,
  nowMs: number = Date.now()
): boolean {
  if (lastAddedAtMs == null) return false;
  return nowMs - lastAddedAtMs < RECENT_ADD_HIGHLIGHT_MS;
}

/**
 * Fermeture manuelle : le rappel reste caché jusqu'au prochain ajout au panier
 * (une date d'activation plus récente que le moment de la fermeture).
 */
export function isCartFinalizePromptDismissed(
  dismissedAtMs: number | null,
  lastAddedAtMs: number | null
): boolean {
  if (dismissedAtMs == null) return false;
  if (lastAddedAtMs == null) return true;
  return lastAddedAtMs <= dismissedAtMs;
}

export function shouldAutoOpenCartDrawer(
  lastAddedAtMs: number | null,
  itemCount: number,
  drawerOpen: boolean,
  nowMs: number = Date.now()
): boolean {
  if (drawerOpen || itemCount <= 0) return false;
  if (lastAddedAtMs == null) return false;
  return nowMs - lastAddedAtMs < 2_000;
}

export { RECENT_ADD_HIGHLIGHT_MS };
